// HotX Console 0.1.107, 2026-09-16 11:27:15 CST, parent ededcab95716ac1a5dced24f1c7bf368ce280467.
import type {
  DomainAccessPreview,
  DomainAccessPreviewSelection
} from '../../api/pointApi';
import type { DomainPackageSelection } from './domainPlanPartitions';

export type { DomainAccessPreview } from '../../api/pointApi';

export function accessPreviewSelection(
  planKey: string,
  autoRenew = true,
  partitionSelection?: DomainPackageSelection | null
): DomainAccessPreviewSelection | null {
  if (partitionSelection) return { ...partitionSelection };
  const key = String(planKey || '').trim().toUpperCase();
  if (key === 'FREE') return { mode: 'FREE', autoRenew };
  if (/^PUSH:\d+$/.test(key)) return { mode: 'ADMIN_PUSH' };

  const existing = key.match(/^PARTITION:EXISTING:(\d+)$/);
  if (existing) return { mode: 'EXISTING', partitionId: Number(existing[1]) };

  const selectedPlan = key.match(/^(?:PARTITION:NEW|PAID):(\d+)$/);
  if (selectedPlan) return {
    mode: 'NEW',
    planId: Number(selectedPlan[1]),
    periodCount: 1,
    autoRenew,
    purchaseConfirmed: true
  };
  return null;
}

export function previewDnsRecordValue(
  recordType: 'A' | 'CNAME',
  cnameTarget: string,
  preview: DomainAccessPreview | null | undefined,
  waitingText: string
) {
  if (recordType === 'CNAME') return cnameTarget;
  return preview?.state === 'READY' && preview.addresses.length
    ? preview.addresses.join(' / ')
    : waitingText;
}
